exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.field[data-v-1a452e28] {\n  margin: 0;\n  padding: 0;\n  min-height: auto;\n  width: auto;\n  min-width: 50px;\n}\n.editable-input-field__nowrap[data-v-1a452e28] {\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n}\n.without-pseudoclasses[data-v-1a452e28]:before, .without-pseudoclasses[data-v-1a452e28]:after {\n  display: none;\n}\n.text-align-right[data-v-1a452e28] {\n  text-align: right;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1a452e28","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/common/fields/EditableInputField.vue
// module id = 5h7l
// module chunks = 1